import { InView } from 'react-intersection-observer'
import { Picture } from 'src/components/ui/Image'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'

interface InlineHorizontalBannerProps {
  bannerUrlMobile: string
  bannerUrlDesktop: string
  imageDescription: string
  linkUrl: string
  bannerName?: string
}

export function InlineHorizontalBanner({
  bannerUrlMobile,
  bannerUrlDesktop,
  imageDescription,
  linkUrl,
  bannerName,
}: InlineHorizontalBannerProps) {
  const handleViewed = () => {
    dispatchAmplitudeEvent({
      eventName: 'Promo Feature Viewed',
      eventData: {
        type: 'Contextual',
        'promotional element name': bannerName ?? 'Banner Inline Horizontal',
      },
    })
  }

  const handleClick = () => {
    if (!bannerName) {
      return
    }

    dispatchAmplitudeEvent({
      eventName: 'Promotional Element Selected',
      eventData: {
        type: 'Contextual',
        'promotional element name': bannerName,
      },
    })
  }

  return (
    <InView
      as="section"
      triggerOnce
      onChange={(inView) => {
        if (inView) {
          handleViewed()
        }
      }}
    >
      <div className="inline-horizontal-banner h-full w-full">
        <a href={linkUrl} onClick={handleClick} className="block h-full w-full">
          <Picture
            sources={[
              {
                src: bannerUrlMobile,
                width: 360,
                height: 230,
                media: '(max-width: 767px)',
              },
            ]}
            img={{
              src: bannerUrlDesktop,
              width: 1280,
              height: 360,
              alt: imageDescription,
              loading: 'lazy',
              decoding: 'async',
              className: 'cursor-pointer object-contain w-full h-auto',
            }}
          />
        </a>
      </div>
    </InView>
  )
}
